interface FigmaIconProps {
  className?: string;
  color?: string;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export const FigmaIcon = ({ className = 'w-6 h-6', color = 'currentColor' }: FigmaIconProps) => (
  <svg fill={color} width="800px" height="800px" viewBox="0 0 256 256"  xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M178.94238,94.00049A37.991,37.991,0,0,0,162,22.001H94A37.991,37.991,0,0,0,77.05762,94.00049,37.97671,37.97671,0,0,0,77.05811,162,37.99416,37.99416,0,1,0,132,195.99951V151.28223a37.98414,37.98414,0,1,0,46.94238-57.28174ZM192,60.001a30.03343,30.03343,0,0,1-29.98047,29.99951L162,90l-.03857.001L132,90V30.001h30A30.03406,30.03406,0,0,1,192,60.001ZM138.71729,98.00024A38.32407,38.32407,0,0,0,132,104.71777V98.00012ZM64,60.001a30.03406,30.03406,0,0,1,30-30h30V90H94l-.019.00049A30.03392,30.03392,0,0,1,64,60.001ZM94,225.999A29.99951,29.99951,0,1,1,94,166l30-.00085v30.00036A30.03364,30.03364,0,0,1,94,225.999Zm30-68L94,158a29.99976,29.99976,0,0,1-.019-59.99951L94,98.001l30-.00086ZM162,158a29.99952,29.99952,0,0,1-.03857-59.999H162l.019-.00049A29.99976,29.99976,0,0,1,162,158Z"
    />
  </svg>
);
